module.exports = __webpack_public_path__ + "static/media/mag-glass.06dbfb1f.svg";